import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IDonorProfileDonorData, IDonorProfileDonorDataLookupData, IDonorProfileDonorDataPost } from '@nkr/models/index';
import { FileDocumentType } from '@nkr/enums/document-type';

export interface IDonorProfileDonorDataResponse {
    data: {
        success: boolean;
        results: IDonorProfileDonorData;
    }
}

export interface IDonorProfileDonorDataLookupDataResponse {
    data: {
        success: boolean;
        results: IDonorProfileDonorDataLookupData;
    }
}

export const ActionCreators = {
    getProfileDonorData: (donorId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileDonorDataResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/donor-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getProfileDonorDataLookupData: (donorId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileDonorDataLookupDataResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/donor-data/lookup-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    postProfileDonorData: (donorId: number, centerId: number, data: IDonorProfileDonorDataPost) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileDonorDataResponse> => {
        let formData = new FormData();
        formData.append('Mrn', data.mrn);
        formData.append('CrossReferenceHint', data.crossReferenceHint);
        formData.append('DeclinedAdpReason', data.declinedAdpReason != null ? data.declinedAdpReason.toString() : null);
        formData.append('DeclinedAdpReasonOther', data.declinedAdpReasonOther);
        formData.append('IsActive', data.isActive ? '1' : '0');
        formData.append('SurgeonContactId', data.surgeonContactId.toString());
        formData.append('IsRemoteDirect', data.isRemoteDirect != null ? (data.isRemoteDirect ? '1' : '0') : '-1');
        formData.append('DonationStartDate', data.donationStartDate);
        formData.append('DonationEndDate', data.donationEndDate);
        formData.append('IsWorkedUp', data.isWorkedUp ? '1' : '0');
        formData.append('OriginalRecipientId', data.originalRecipientId.toString());
        formData.append('RelationshipToRecipient', data.relationshipToRecipient);
        formData.append('RelationshipToPatientOther', data.relationshipToPatientOther);
        formData.append('UnosId', data.unosId);
        formData.append('HasFrozenSamples', data.hasFrozenSamples ? '1' : '0');
        formData.append('Alias', data.alias.trim());
        formData.append('CoordinatorId', data.coordinatorId.toString());
        formData.append('UsePhlebotomy', data.usePhlebotomy ? '1' : '0');
        formData.append('DirectCryoSend', data.directCryoSend ? '1' : '0');
        formData.append('DirectXmSend', data.directXmSend ? '1' : '0');
        formData.append('DirectSerologySend', data.directSerologySend ? '1' : '0');
        formData.append('RdnCenterId', data.rdnCenterId.toString());
        formData.append('RemoteWorkupCenterId', data.remoteWorkupCenterId != null ? data.remoteWorkupCenterId.toString() : '-1');
        formData.append('RemoteWorkupDate', data.remoteWorkupDate);
        formData.append('RemoteWorkupBilledDate', data.remoteWorkupBilledDate);
        formData.append('DidRemoteWorkup', data.didRemoteWorkup != null ? data.didRemoteWorkup.toString() : null);
        formData.append('Comments', data.comments);
        formData.append('VoucherConsentsReviewed', data.voucherConsentsReviewed != null ? (data.voucherConsentsReviewed ? '1' : '0') : '-1');
        if (data.consentForm) formData.append('NewConsentFile', data.consentForm);
        formData.append('AppendConsentForm', data.appendConsentForm ? 'true' : 'false');

        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/donor-data`,
            data: formData
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    viewFile: (centerId: number, donorId: number, docType: FileDocumentType) => async (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/document/${docType}`,
            responseType: 'blob'
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
}